import React, { useState } from 'react';
import { Icon } from '@iconify/react';

const baseInput =
  'w-full rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm text-slate-900 shadow-sm placeholder:text-slate-400 focus:border-brand-blue focus:outline-none focus:ring-2 focus:ring-brand-blue disabled:bg-slate-100 disabled:cursor-not-allowed';

const TextField = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  error,
  helperText,
  required = false,
  fullWidth = true,
  disabled = false,
  placeholder,
  multiline = false,
  rows = 3,
  autoFocus = false,
  className,
  showPasswordToggle = false,
  row = false,
  colSpan = 1,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === 'password' && showPasswordToggle;
  const inputType = isPasswordField && showPassword ? 'text' : type;

  const inputClass = [
    baseInput,
    fullWidth ? '' : 'w-auto',
    error ? 'border-red-400' : '',
    isPasswordField ? 'pr-10' : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={['flex gap-1', row ? 'flex-row gap-6' : 'flex-col', fullWidth ? 'w-full' : '', colSpan ? `col-span-${colSpan}` : ''].filter(Boolean).join(' ')}>
      {label && (
        <label htmlFor={name} className="text-sm font-medium text-slate-700 text-left">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        {multiline ? (
          <textarea
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            rows={rows}
            disabled={disabled}
            autoFocus={autoFocus}
            className={inputClass}
            {...props}
          />
        ) : (
          <input
            id={name}
            name={name}
            type={inputType}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            autoFocus={autoFocus}
            className={inputClass}
            {...props}
          />
        )}
        {isPasswordField && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-700 focus:outline-none"
            tabIndex={-1}
          >
            <Icon
              icon={showPassword ? 'lucide:eye-off' : 'lucide:eye'}
              className="h-5 w-5"
            />
          </button>
        )}
      </div>
      {helperText && (
        <p className={['text-xs text-left', error ? 'text-red-500' : 'text-slate-500'].join(' ')}>
          {helperText}
        </p>
      )}
    </div>
  );
};

export default TextField;

